import React, { useContext, useEffect, useRef, useState, useCallback } from 'react'
import styled, { ThemeContext } from 'styled-components'
// import { TYPE } from '../../theme'
import { Text } from 'rebass'
import { BigNumber } from 'bignumber.js'
import { useHistory } from 'react-router-dom';

// import reportImg from '../../assets/images/report.png'
// import voteImg from '../../assets/svg/vote.svg'
// import moreImg from '../../assets/svg/more.svg'
// import moreImgLight from '../../assets/svg/more_light.svg'
import infoFold from '../../assets/svg/info_fold.svg'
import infoUp from '../../assets/svg/info_up.svg'
import infoBake from '../../assets/svg/info_bake.svg'
import profileLink from '../../assets/svg/profile_link.svg'

import Row, { RowColumn } from '../../components/Row'

import { BIGNUMBER_FMT } from '../../constants/bakery'
import { MARKETTYPEV1, MARKETTYPE, MARKETTYPEV3, MARKETMULTITOKEN } from '../../constants/bakery/nft'

import { userMarketType } from '../../userType/userMarketType'

const TextRowColumn = styled(RowColumn)`
  padding: 25px 0 0;
  width: 100%;
  background: ${({ theme}) => theme.bsBg41};
  box-shadow: ${({ theme}) => theme.boxShadow1};
  border-radius: 11px;
  font-family: 'Roboto-Regular';
  .infoBake {
    margin: -12px -40px 0 0;
  }
  .infoTextFold {
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }
  .infoTextUnFold {
    height: auto;
  }
  .infoMinHeight {
    min-height: 175px;
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
    .title-Row {
      height: auto;
      align-items: flex-start; 
    }
    .infoBake {
      margin: -25px -40px 0 0;
    }
  `}
`
const TextAutoRow = styled(Row)<{padding?: string, autoColumn?: boolean}>`
  padding: ${({ padding}) => padding ? padding : '0 24px'};
  align-items: center;
  justify-content: space-between;
  .title {
    word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  ${({ theme, autoColumn }) => theme.mediaWidth.upToMedium`
    width: auto;
    left: 20px;
    right: 20px;
    ${autoColumn &&`
      flex-direction: column;
    `}
    button {
      margin: 10px 0 0;
    }
    .title {
      -webkit-line-clamp: 5;
    }
  `}
`
const TextLabel = styled.div<{width?: string, height?: number, color?: string; family?: string; size?: number; top?: string; maxWidth?: string}>`
  width: ${({width}) => (width ? width : 'auto')};
  max-width: ${({maxWidth}) => (maxWidth ? maxWidth : 'auto')};
  line-height: ${({height}) => (height ? height : 28)}px;  
  color: ${({color}) => (color)};
  font-family: ${({family}) => (family ? family : 'Roboto-Regular')}!important;
  font-size: ${({size}) => (size ? size : 28)}px;
  margin: ${({top}) => (top ? top : 0)};
  .name{
    cursor: pointer;
    text-decoration: underline;
  }
`
const Report = styled.a`
  padding: 0 10px;
  width: 80px;
  line-height: 32px;
  color: ${({ theme }) => theme.bsText28};
  background: ${({ theme}) => theme.bsBg41};
  border: 1px solid ${({ theme}) => theme.bsBorder2};
  border-radius: 35px;
  font-family: 'Roboto-Medium';
  font-size: 13px;
  text-align: center;
  text-decoration: none!important;
  text-decoration: underline;
  cursor: pointer;
`
// const VoteNum = styled.div`
//   margin-right: 9px;
//   padding: 0 10px;
//   min-width: 80px;
//   line-height: 32px;
//   background: ${({ theme}) => theme.bsBg29};
//   border: 1px solid ${({ theme}) => theme.darkMode ? 'none' : theme.bsBorder7};
//   box-sizing: border-box;
//   border-radius: 35px;
//   color: ${({ theme}) => theme.bsText7};
//   font-family: 'Roboto-Bold';
//   font-size: 14px;
//   text-align: center;
//   img {
//     display: inline-block;
//     margin-right: 5px;
//     width: 14px;
//     height: 12px;
//     vertical-align: middle;
//   }
// `
// const Website = styled.a`
//   width: 66px;
//   line-height: 28px;
//   border-radius: 10px;
//   cursor: pointer;
//   text-decoration: underline;
//   margin-left: 10px;
//   color: ${({ theme }) => theme.bsText12};
// `
// const linkExp = new RegExp(/^https?:\/\/([\w-]+\.)+[\w-]+.*$/)
// const InfoDes = styled.div`
//   height: 313px;
//   margin-top: 17px;
//   font-size: 16px;
//   line-height: 28px;
//   color: ${({ theme }) => theme.bsText4};
//   font-family: 'Yuanti SC';
//   letter-spacing: 0;
//   white-space: pre-wrap;
//   word-wrap: break-word;
//   overflow-y: scroll;
//   ${({ theme }) => theme.mediaWidth.upToBigerLarge`
//     height: auto;
//   `}
//   ${({ theme }) => theme.mediaWidth.upToMedium`
//     text-align: center;
//     min-height: 50px;
//   `}
// `
// const PriceRow = styled(Row)`
//   margin-top: 10px;
//   height: 67px;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   ${({ theme }) => theme.mediaWidth.upToMedium`
//     justify-content: center;
//   `}
// `
// const Price = styled.div`
//   display: flex;
//   align-items: center;
// `
// const HotRow = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   ${({ theme }) => theme.mediaWidth.upToMedium`
//     flex-wrap: wrap;
//     justify-content: center;
//   `}
// `
const AuthorText = styled(Row)`
  line-height: 34px;
  img {
    margin-right: 7px;
    display: inline-block;
    width: 34px;
    height: 34px;
    vertical-align: middle;
    border-radius: 100%;
  }
  span {
    font-family: 'Roboto-Bold';
    font-size: 16px;
    color: ${({ theme }) => theme.bsText28};
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    cursor: pointer;
  }
`
const FeeText = styled(Row)`
  margin-left: 10px;
  width: 213px;
  height: 32px;
  background: ${({ theme }) => theme.bsBg33};
  border-radius: 35px;
  flex-shrink: 0;
  justify-content: center;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin: 20px 0 0;
  `}
`
const Royalties = styled.div`
  font-size: 13px;
  background: ${({ theme }) => theme.btnBg3};
  -webkit-background-clip: text;
  color: transparent;
`
// const Report = styled(Website)`
//   display: flex;
//   padding: 0 20px;
//   width: auto;
//   height: 32px;
//   background: ${({ theme }) => theme.bsText1};
//   border: 1px solid ${({ theme }) => theme.bsBorder1};
//   text-decoration: none;
//   align-items: center;
//   img {
//     margin-right: 6px;
//     width: 17px;
//     height: 16px;
//   }
//   ${({ theme }) => theme.mediaWidth.upToMedium`
//     margin: 10px auto 0;
//   `}
// `
const InfoText = styled.div`
  margin: 30px 24px 0;
  padding: 30px 0px 0;
  font-size: 14px;
  line-height: 24px;
  box-sizing: border-box;
  word-wrap: break-word;
  color: ${({ theme }) => theme.darkMode ? theme.bsText29 : theme.bsText28};
  border-top: 1px solid ${({ theme }) => theme.bsBorder8};
`
const InfoTextCopy = styled.div`
  position: absolute;
  left: -9999px;
  width: 562px;
  line-height: 24px;
  font-size: 14px;
  color: ${({theme}) => theme.bsText7};
  font-family: 'Roboto-Regular';
  word-wrap: break-word;
  height: auto;
  visibility: hidden;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: auto;
    left: 20px;
    right: 20px;
  `}
`
const InfoFold = styled.div<{bg?: boolean}>`
  margin-top: ${({bg}) => bg ? 0 : '-22px'};
  background: ${({bg, theme}) => bg ?  theme.bsBg43 : theme.bsBg44};
  padding: 28px 0 22px;
  text-align: center;
  cursor: pointer;
`
const RotateImg = styled.img<{width?: string, height?: string, isRotate?: boolean}>`
  width: ${({width}) => width ? width : '16px'};
  height: ${({height}) => height ? height : 'auto'};
  transform: ${({isRotate}) => isRotate ? 'rotate(180deg)' : 'rotate(0deg)'};
  -webkit-transform: ${({isRotate}) => isRotate ? 'rotate(180deg)' : 'rotate(0deg)'};
  transition: transform .5s;
  cursor: pointer;
`
const Details = styled(TextAutoRow)<{isShadow?: boolean}>`
  padding: 0 24px;
  line-height: 72px;
  border-top: 1px solid ${({ isShadow, theme }) => isShadow ? 'none' : theme.bsBorder8};
  box-shadow: ${({ isShadow }) => isShadow ? '0px 1.75625px 17.5625px rgba(171, 133, 115, 0.08)' : 'none'};
  cursor: pointer;
`
const InfoApy = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  margin: 30px 24px 0;
  padding: 20px 0 0;
  height: 79px;
  font-size: 14px;
  font-family: 'Roboto-Regular';
  color: ${({ theme }) => theme.darkMode ? theme.bsText29 : theme.bsText28};
  border-top: 1px solid ${({ theme }) => theme.bsBorder8};
  border-bottom: 1px solid ${({ theme }) => theme.bsBorder8};
  ${({ theme }) => theme.mediaWidth.upToInfoLarge`
    height: auto;
    min-height: 79px;
    flex-wrap: wrap;
  `}
`
const Website = styled.a`
  width: 20px;
  cursor: pointer;
  text-decoration: underline;
  margin-left: 5px;
  img {
    width: 12px;
    height: 12px;
    border-radius: 0;
  }
`
const linkExp = new RegExp(/^https?:\/\/([\w-]+\.)+[\w-]+.*$/)

export default function Introduction ({artwork, tokenName, soltButton, soltApy, soltAddress}: {artwork: any, tokenName?: string, soltButton?: any, soltApy?: any, soltAddress?: any}) {
  const theme = useContext(ThemeContext)
  const history = useHistory();
  const goUserCenter = (type: any) => {
    // const {creator, author} = artwork
    // history.push(`/usercenter/${creator}?artist=${author}`)
    const {creator, owner} = artwork
    const next = type === 'create' ? creator : owner
    const tab = type === 'create' ? 'CREATED' : 'COLLECTED'
    history.push(`/usercenter/${next}?type=${tab}`)
  }

  const marketType = userMarketType(artwork.nftType + '', artwork.nftLevel)
  const introductCopyRef = useRef<any>()
  const [isShowInfo, setIsShowInfo] = useState(false)
  const [isShowBtn, setIsShowBtn] = useState(false)
  useEffect(() => {
    const height = introductCopyRef && introductCopyRef.current && introductCopyRef.current.offsetHeight
    if (height > 96) {
      setIsShowInfo(true)
      setIsShowBtn(true)
    } else {
      setIsShowInfo(false)
      setIsShowBtn(false)
    }
  }, [setIsShowInfo, setIsShowBtn, artwork.description])

  const openInfo = useCallback(() => {
    setIsShowInfo(!isShowInfo)
  }, [isShowInfo, artwork.description])

  const [isShowDetails, setIsShowDetails] = useState(false)
  const openDetails = useCallback(() => {
    setIsShowDetails(!isShowDetails)
  }, [isShowDetails])

  let cssTwo: any = true
  if ([MARKETTYPE.DOGGYNFT, MARKETTYPEV3.DOGGYNFTV3, MARKETTYPEV1.BARKNFTV1, MARKETTYPE.BARKNFT, MARKETTYPEV3.BARKNFTV3, MARKETTYPE.POKERCARD,
      MARKETTYPEV3.POKERCARDV3, MARKETTYPE.CARNFT, MARKETTYPEV3.CARNFTV3, MARKETMULTITOKEN.EQUIPMENTMULTITOKEN, MARKETTYPEV3.EQUIPMENTV3,
      MARKETTYPEV1.PETNFTV1, MARKETTYPE.PETNFT, MARKETTYPEV3.PETNFTV3, MARKETTYPEV1.WEAPONNFTV1, MARKETTYPE.WEAPONNFT, MARKETTYPEV3.WEAPONNFTV3,
      MARKETTYPEV1.EGGNFTV1, MARKETTYPE.EGGNFT, MARKETTYPEV3.EGGNFTV3, MARKETTYPEV1.DISHV1, MARKETTYPE.DISH, MARKETTYPEV3.DISHV3].includes(marketType)) {
    cssTwo = false
  }

  return (
    <>
      {
        artwork 
        ?
        <TextRowColumn>
          <TextAutoRow padding="0 24px 29px" height="63px" className="title-Row">
            <TextLabel color={theme.bsText28} size={28} family="Roboto-Bold"  maxWidth="420px" className="title">{artwork.name}</TextLabel>
            {/* <Report href={'https://docs.google.com/forms/d/e/1FAIpQLSePTf_IgOIVKj5vqoJbysHj1YQXU-IjoBd5XPUcZ3MuTd62xQ/viewform?usp=pp_url&entry.925770343=' + window.location.protocol + '//' + window.location.host + '/%23' + (window.location.hash.replace(/#/, '').replace('&', '%26'))} target="_blank">
              <img src={reportImg} alt=""/>
              <Text color={theme.bsText7} fontFamily="Roboto" fontWeight="700">Report</Text>
            </Report> */}
            <Row style={{width: 'auto', flexShrink: 0}}>
              {/* {
                [
                  MARKETTYPE.BAKERYARTWORK,
                  MARKETTYPE.MEME, 
                  MARKETTYPE.MUSKDOGE, 
                  MARKETTYPE.ONEINCH,
                  MARKETTYPE.SFPARTWORK,
                  MARKETTYPE.LOVE,
                  MARKETTYPE.RACANFT
                ].includes(marketType) ? (
                  <VoteNum>
                    <img src={voteImg} alt="" />
                    {artwork.votes}
                  </VoteNum>
                ) : ''
              } */}
              <img className="infoBake" src={infoBake} alt="" />
              {/* <VoteNum>
                <img src={voteImg} alt="" />
                {artwork.votes}
              </VoteNum> */}
              <Report href={'https://docs.google.com/forms/d/e/1FAIpQLSePTf_IgOIVKj5vqoJbysHj1YQXU-IjoBd5XPUcZ3MuTd62xQ/viewform?usp=pp_url&entry.925770343=' + window.location.protocol + '//' + window.location.host + '/%23' + (window.location.hash.replace(/#/, '').replace('&', '%26'))} target="_blank">Report</Report>
              {/* <img src={theme.darkMode ? moreImgLight : moreImg} alt="" /> */}
            </Row>
          </TextAutoRow>
          <TextAutoRow autoColumn={true}>
            <Row style={{width: '100%', flexShrink :1}}>
              <div style={{width: '50%'}}>
                <TextLabel color={theme.bsText30} size={14} family="Roboto-Medium" maxWidth="570px">Creator</TextLabel>
                <AuthorText onClick={() => goUserCenter('create')}>
                  <img src={artwork.attributes && artwork.attributes.avatar ? artwork.attributes.avatar : 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/271129eb168e43aba962134e6989f0d7.jpg'} alt="" />
                  <span>{artwork.attributes && artwork.attributes.nick ? artwork.attributes.nick : '-'}</span>
                  {
                    artwork.attributes && artwork.attributes.public_profile_link && linkExp.test(artwork.attributes.public_profile_link) 
                    ?
                    <Website href={ artwork.attributes && artwork.attributes.public_profile_link ? artwork.attributes.public_profile_link : 'javascript:void(0)'} target="_blank" onClick={(event) => {event.stopPropagation()}}>
                      <img src={profileLink} alt=""/>
                    </Website>
                    : null
                  }
                </AuthorText>
              </div>
              <div style={{width: '50%'}}>
                <TextLabel color={theme.bsText30} size={14} family="Roboto-Medium" maxWidth="570px">Owner</TextLabel>
                <AuthorText onClick={() => goUserCenter('collection')}>
                  <img src={artwork.ownerInfo && artwork.ownerInfo.avatar ? artwork.ownerInfo.avatar : 'https://d3ggs2vjn5heyw.cloudfront.net/static/nfts/artworks/271129eb168e43aba962134e6989f0d7.jpg'} alt="" />
                  <span>{artwork.ownerInfo && artwork.ownerInfo.nick ? artwork.ownerInfo.nick : '-'}</span>
                </AuthorText>
              </div>
            </Row>
            {
              [MARKETTYPE.BAKERYBSCARTWORK, MARKETTYPEV3.BAKERYBSCARTWORKV3].includes(marketType) && artwork.attributes.creatorRoyalties ? (
                <FeeText style={artwork.nftLevel !== 'v3' ? {background: '#DBDBDB', color: '#898989'} : {}}>
                  <Royalties>{artwork.attributes.creatorRoyalties ? artwork.attributes.creatorRoyalties / 100 : 0}%</Royalties>
                  <Text fontSize={13} color={theme.bsText28} fontFamily={'Roboto-Regular'} marginLeft="2px">of sales will go to creator</Text>
                </FeeText>
              ) : null
            }
          </TextAutoRow>
          <TextAutoRow padding="30px 24px 0" autoColumn={true}>
            <Row>
              <Text fontSize={35} color={theme.bsText28} fontFamily={'Roboto-Bold'} lineHeight="42px">
                {artwork.price
                ? (new BigNumber(!artwork.auctionPrice ? artwork.price : artwork.maxBidPrice).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT)) 
                : '-'}</Text>
              <Text fontSize={14} color={theme.bsText28} fontFamily={'Roboto-Bold'} marginLeft="5px">{artwork.tokenName}</Text>
              {/* <Text fontSize={14} color={theme.bsText29} fontFamily={'Roboto-Medium'} marginLeft="8px">($2,388.30)</Text> */}
            </Row>
            {
              (artwork.name || artwork.creator) && soltButton ? soltButton : null
            }
          </TextAutoRow>
          {
            cssTwo ? (
              <>
                <InfoText className={!isShowInfo ? isShowBtn ? 'infoTextUnFold' : 'infoMinHeight' : 'infoTextFold'}>
                  { artwork.description }
                </InfoText>
                <InfoTextCopy ref={introductCopyRef as any}>
                  { artwork.description }
                </InfoTextCopy>
                {
                  isShowBtn && (
                    <InfoFold bg={!isShowInfo} onClick={() => openInfo()}>
                      <RotateImg isRotate={!isShowInfo} src={infoFold} alt=""></RotateImg>
                    </InfoFold>
                  )
                }
              </>
            ) : (
              <InfoApy>
                {
                  soltApy && soltApy
                }
              </InfoApy>
            )
          }
          {
            cssTwo ? (
              <>
                <Details align="center" padding="20px 0 0" isShadow={isShowDetails} onClick={() => openDetails()}>
                  <Text fontSize={20} color={theme.bsText28} fontFamily={'Roboto-Bold'}>Details</Text>
                  <RotateImg width="12px" isRotate={isShowDetails} src={infoUp} alt="" />
                </Details>
                {
                  isShowDetails && soltAddress ? soltAddress : null
                }
              </>
            ) : (
              soltAddress && soltAddress
            )
          }
        </TextRowColumn>
        : null
      }
    </>
  )
}
